<template>
  <div class="channel-tabbar">
    <van-tabbar
      :value="current"
      active-color="#FF745B"
      inactive-color="#BCC2CF"
      placeholder
      :safe-area-inset-bottom="true"
    >
      <van-tabbar-item
        v-for="item in tabbarList"
        :key="item.name"
        :name="item.name"
        :badge="item.badge || ''"
        @click="onChange(item.name)"
      >
        <span>{{ item.text }}</span>
        <template #icon="props">
          <img
            :src="
              props.active
                ? require(`./images/${item.name}-active.png`)
                : require(`./images/${item.name}.png`)
            "
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from 'vant'

export default {
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem
  },
  data() {
    return {}
  },
  props: {
    tabbarList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    current() {
      const { path } = this.$route
      const target = this.tabbarList.find(item => item.path === path)
      if (target) {
        return target.name
      }
      return 'home'
    }
  },
  methods: {
    onChange(name) {
      const target = this.tabbarList.find(item => item.name === name)
      const { path } = this.$route
      if (path === target.path) {
        return
      }
      if (target && target.onChange) {
        target.onChange()
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../../../scss/functions';

.channel-tabbar {
  .van-tabbar--fixed {
    position: fixed !important;
    // 兼容pc
    width: 10rem;
    left: 50%;
    transform: translate(-50%, 0);
    box-shadow: 0px pxToRem(-4) pxToRem(20) 0px rgba(0, 0, 0, 0.06);
  }
  .van-tabbar-item__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: pxToRem(48);
    height: pxToRem(48);
    margin-right: pxToRem(4);
    margin-bottom: 0 !important;
    img {
      width: 100%;
      object-fit: cover;
    }
  }
  .van-tabbar-item__text {
    font-size: pxToRem(24);
    line-height: pxToRem(36);
  }
  .van-tabbar-item {
    flex-direction: row;
  }
  .van-info {
    background: linear-gradient(33deg, #ff4f45 0%, #fe9f9c 100%);
    color: #fff;
    font-size: pxToRem(16);
    transform: translateY(-60%) scale(0.95);
    left: pxToRem(24);
    right: auto;
  }
}
</style>
